<app-card-widget title="Financing Holds" [subtitle]="subtitle(invoice)" *ngIf="invoice$ | async as invoice">

  <div class="card-section-container">
    <div class="card-section">
      <p class="no-holds" *ngIf="!invoice.financing_holds?.length">No financing hold applies to this invoice.</p>

      <mat-list *ngIf="invoice.financing_holds?.length">
        <mat-list-item class="financing-hold" *ngFor="let hold of invoice.financing_holds; trackBy: trackByHoldId">
          <mat-icon matListIcon color="warn">pan_tool</mat-icon>
          <h3 matLine>
            <span class="hold-scope">{{ scopeLabel(hold) }}:</span>
            <span class="hold-reason">{{ hold.reason }}</span>
          </h3>
          <span matLine class="hold-placed">Placed by {{ hold.placed_by?.name }} on {{ hold.placed_at | date: 'd.M.yyyy' }}</span>
          <!-- The wrapper span carries the tooltip because a disabled button
               emits no pointer events, and is focusable only while there is
               something to explain (see the state widget's Reset). -->
          <ng-container *ngIf="{ allowed: canRelease$ | async } as releaseGate">
            <span
              class="release-action"
              [matTooltip]="releaseGate.allowed === false ? releasePermissionTooltip : ''"
              [attr.tabindex]="releaseGate.allowed === false ? 0 : null">
              <button
                type="button"
                mat-button
                color="primary"
                class="release-button"
                [disabled]="releaseGate.allowed !== true"
                (click)="release(invoice, hold)">Release</button>
            </span>
          </ng-container>
        </mat-list-item>
      </mat-list>
    </div>
  </div>

  <mat-card-actions align="end">
    <!-- Releasing several holds with one note
         (place-and-release-several-financing-holds, design D6): offered
         from two holds up, since with one the row's own Release does the
         same, and gated like it. -->
    <ng-container *ngIf="(invoice.financing_holds?.length || 0) >= 2">
      <ng-container *ngIf="{ allowed: canRelease$ | async } as releaseGate">
        <span
          class="release-holds-action"
          [matTooltip]="releaseGate.allowed === false ? releasePermissionTooltip : ''"
          [attr.tabindex]="releaseGate.allowed === false ? 0 : null">
          <button
            type="button"
            mat-button
            color="primary"
            class="release-holds-button"
            [disabled]="releaseGate.allowed !== true"
            (click)="releaseSeveral(invoice)">Release holds</button>
        </span>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="{ allowed: canPlace$ | async } as placeGate">
      <span
        class="place-action"
        [matTooltip]="placeGate.allowed === false ? placePermissionTooltip : ''"
        [attr.tabindex]="placeGate.allowed === false ? 0 : null">
        <button
          type="button"
          mat-button
          color="warn"
          class="place-button"
          [disabled]="placeGate.allowed !== true"
          (click)="place(invoice)">Place hold</button>
      </span>
    </ng-container>
  </mat-card-actions>

</app-card-widget>
